<template>
  <el-container class="layou">
    <el-header class="header" v-if="header">
      <slot name="header">header</slot>
    </el-header>
    <el-container class="content">
      <el-aside v-if="left" :width="mxchmLeft" class="left hidden-sm-and-down">
        <slot name="left">left</slot>
      </el-aside>
      <el-main class="main">
        <slot name="main">main</slot>
      </el-main>
      <el-aside
        :width="mxchmRight"
        v-if="right"
        class="right hidden-md-and-down right-aside right-aside-search"
      >
        <slot name="right">right</slot>
      </el-aside>
      <el-footer v-if="footer">
        <slot name="footer"> </slot>
      </el-footer>
    </el-container>
    <slot></slot>
  </el-container>
</template>

<script>
export default {
  props: {
    header: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: false
    },
    mxchmRight: {
      type: String,
      default: "300px"
    },
    mxchmLeft: {
      type: String,
      default: "220px"
    }
  }
};
</script>

<style>
.el-container,
.el-header,
.el-aside,
.el-main {
  width: 100%;
  height: 100%;
  /* border: 1px #ccc solid; */
  overflow: hidden;
  line-height: unset;
  height: 100%;
}
.el-footer {
  padding: 0;
}
.layou {
  margin: 0 auto;
}
.layou .header {
  height: 60px;
  padding: 0;
  position: fixed;
  background-color: rgb(50, 55, 70);
}

.layou .content {
  width: 100%;
  margin: 60px auto 0 auto;
  position: relative;
}
.layou .el-header {
}
.layou .left {
}
.layou .right {
}
.layou .main {
  /*overflow: unset;*/
}
.layou .main .search1 .right {
  margin-top: 120px;
}

.Mxchm_layou .el-header {
  background-color: #323746;
}

.search .el-header {
  background-color: #323746;
}

@media screen and (max-width: 1263px) {
  .layou .content {
    width: 100%;
    margin-top: 70px;
    margin: 70px auto 0 auto;
  }
  .layou .header {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layou/index.vue